module.exports = __webpack_public_path__ + "static/img/GCS.876e8cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GCS.svg
// module id = 3ODh
// module chunks = 1